import { createAction } from 'redux-actions';
export const markEditorFocused = createAction('DA_EDITOR.MARK_FOCUSED', (editorKey)=>({
        editorKey
    }));
export const markEditorInactive = createAction('DA_EDITOR.MARK_INACTIVE', (editorKey)=>({
        editorKey
    }));
// TODO: use action key constant
export const saveEditorDraft = createAction('DA_EDITOR.SAVE_EDITOR_DRAFT', (editorId, editorState)=>({
        editorId,
        editorState
    }));
export const removeEditorDraft = createAction('DA_EDITOR.REMOVE_EDITOR_DRAFT', (editorId)=>({
        editorId
    }));
export const uploadDraggedFile = createAction('DA_EDITOR.UPLOAD_DRAGGED_FILE', (file, uploadHelpers)=>({
        file,
        uploadHelpers
    }));
